var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 20,
    viewBox: "0 0 10 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_458_13280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.6873 5.70311C9.68029 8.72334 9.71221 12.6637 9.6873 15.6835C9.6873 17.8222 6.92215 19.9609 4.84829 19.9609C2.77444 19.9609 0.00930234 17.8222 0.00930234 15.6835C0.0248119 11.8467 -0.0179144 7.47865 0.00930234 3.56442C0.00930234 1.42576 1.39187 0 3.46573 0C5.53958 0 6.92215 1.42576 6.92215 3.56442C6.92215 5.70309 6.94897 9.89752 6.92215 12.832C6.92215 14.2578 6.23086 15.6835 4.84829 15.6835C3.46572 15.6835 2.77445 14.2578 2.77445 12.832V5.70311C2.77445 4.27733 4.15701 4.27733 4.15701 5.70311V12.832C4.15701 14.2578 5.53959 14.2578 5.53959 12.832C5.53959 11.4062 5.56371 6.42699 5.53959 3.56442C5.48566 2.29675 4.8483 1.42577 3.46573 1.42577C2.08316 1.42577 1.39187 2.13865 1.39187 3.56442V15.6835C1.43639 17.5722 3.46572 18.5351 4.84829 18.5351C6.23086 18.5351 8.30472 17.1093 8.30472 15.6835V5.70311C8.30472 4.27733 9.6873 4.27733 9.6873 5.70311Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_458_13280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClip);
export default __webpack_public_path__ + "static/media/clip.9499b383.svg";
export { ForwardRef as ReactComponent };